const studentSpace = {
  path: 'studentSpace',
  component: resolve => require(['../../../../components/pages/signUp/studentSpace'], resolve)
}
export default studentSpace



// WEBPACK FOOTER //
// ./src/router/pages/signUp/studentSpace/index.js